module.exports = __webpack_public_path__ + "img/5_76.4e3a010d.png";